// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Slider_wrapper__NNYjw","slide":"Slider_slide__W9waM","pagination":"Slider_pagination__Cf_aS","dot":"Slider_dot__mcSHo","dot_active":"Slider_dot_active__GB_ma"};